export const PdpTypeLabel = {
  1: "Por Cliente",
  2: "Por Producto",
};

export const ReportTypes = {
  PayPromise: 7,
  InboundVoice: 8,
  Sells: 11,
  Atc: 12,
  CustomerSupport: 13,
  Forms: 14,
  Calls: 15,
  IvrAutomatic: 18,
  IvrSurvey: 17,
  MessagingTickets: 19,
  Strategies: 20,
  Phones: 21,
  LeadsResume: 22,
  CapturedLeads: 23,
  MessageTicketsTransfer: 24,
  ContactProducts: 25,
  CallAttempts: 26,
  CallsAnswered: 27,
  IncomingPerAgent: 28,
  Callback:29,
  AtcMessaging: 30,
};

export const CustomerSupportReportTypes = {
  Resume: 1,
  TimeSection: 2,
  DailyManagement: 3,
  Abandoned: 4,
  UsersManagement: 5,
};

export const PayPromiseReportTypes = Object.freeze({
  Ranking: 1,
  Progress: 2,
  List: 3,
});

export const CustomerSupportReportTypesNames = {
  [CustomerSupportReportTypes.Resume]: "RESUMEN",
  [CustomerSupportReportTypes.TimeSection]: "TIME_SLOT",
  [CustomerSupportReportTypes.DailyManagement]: "DAILY_MANAGEMENT",
  [CustomerSupportReportTypes.Abandoned]: "DROPPED_CALLS",
  [CustomerSupportReportTypes.UsersManagement]: "USERS_MANAGEMENT",
};

export const PayPromiseReportTypesNames = Object.freeze({
  [PayPromiseReportTypes.Ranking]: "RANKING_PDP",
  [PayPromiseReportTypes.Progress]: "CONTROL_PDP",
  [PayPromiseReportTypes.List]: "LIST_PDP",
});

export const SubtypesByReport = {
  [ReportTypes.CustomerSupport]: {
    label: "atención al cliente",
    options: [
      { value: CustomerSupportReportTypes.Resume, label: "Resumen" },
      { value: CustomerSupportReportTypes.TimeSection, label: "Tramo horario" },
      { value: CustomerSupportReportTypes.DailyManagement, label: "Gestión diaria" },
      { value: CustomerSupportReportTypes.Abandoned, label: "Abandonadas" },
      { value: CustomerSupportReportTypes.UsersManagement, label: "Gestión de usuarios" },
    ],
  },
  [ReportTypes.PayPromise]: {
    label: "promesa de pago",
    options: [
      { value: PayPromiseReportTypes.Ranking, label: "Ranking de PDP por usuario" },
      { value: PayPromiseReportTypes.Progress, label: "Control de avance de PDP" },
      { value: PayPromiseReportTypes.List, label: "Listado de PDP" },
    ],
  },
};

export const Months = {
  ene: "Enero",
  feb: "Febrero",
  mar: "Marzo",
  abr: "Abril",
  may: "Mayo",
  jun: "Junio",
  jul: "Julio",
  ago: "Agosto",
  sep: "Setiembre",
  oct: "Octubre",
  nov: "Noviembre",
  dic: "Diciembre",
};

export const MonthName = {
  "01": "Ene",
  "02": "Feb",
  "03": "Mar",
  "04": "Abr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Ago",
  "09": "Set",
  10: "Oct",
  11: "Nov",
  12: "Dic",
};

export const ReportDocs = {
  [1]: {
    slug: "tipificaciones-por-contacto",
    text:
      "Examina las razones clasificadas de cada interacción, agrupadas por contacto y el desempeño de tus agentes."
  },
  [10]: {
    slug: "tipificaciones-por-producto",
    text:
      "Comprende cómo se distribuyen las tipificaciones según los productos o servicios ofrecidos."
  },
  [3]: {
    slug: "tipificaciones-por-hora",
    text:
      "Analiza los resultados de los tickets y la evolución de las tipificaciones dentro de un rango horario específico."
  },
  [4]: {
    slug: "tiempo-en-plataforma",
    text:
      "Controla el tiempo total que tus agentes permanecen activos en la plataforma, por día o por rango de fechas."
  },
  [5]: {
    slug: "reporte-de-logs-por-acw",
    text:
      "Audita las llamadas que quedaron sin tipificar o sin completar una gestión por falta de tiempo."
  },
  [6]: {
    slug: "reporte-de-tipificaciones-por-acw",
    text:
      "Consulta cómo los agentes clasifican los contactos durante su tiempo de post-llamada (After Call Work)."
  },
  // [ReportTypes.PayPromise]: {
  //   slug: "PayPromise",
  //   text:
  //     "PayPromise"
  // },
  [ReportTypes.InboundVoice]: {
    slug: "reporte-de-llamadas-entrantes",
    text:
      "Evalúa el rendimiento del canal inbound con métricas de llamadas recibidas, atendidas, perdidas o abandonadas."
  },
  // [ReportTypes.Sells]: {
  //   slug: "",
  //   text:
  //     "Sells"
  // },
  // [ReportTypes.Atc]: {
  //   slug: "",
  //   text:
  //     ""
  // },
  [ReportTypes.CustomerSupport]: {
    slug: "reporte-atc",
    text:
      "Monitorea tiempos de respuesta, resolución y satisfacción del cliente para medir la efectividad de tu equipo."
  },
  [ReportTypes.Forms]: {
    slug: "reporte-de-formularios",
    text:
      "Consulta las respuestas obtenidas mediante formularios usados durante las interacciones con los clientes."
  },
  [ReportTypes.Calls]: {
    slug: "reporte-de-llamadas",
    text:
      "Visualiza el historial completo de llamadas con detalles como duración, tipo, agente responsable y estado final."
  },
  [ReportTypes.IvrAutomatic]: {
    slug: "ivr-operador-automatico",
    text:
      "Comprende el comportamiento de los contactos en el flujo, evalúa la eficiencia del IVR y las decisiones tomadas por el usuario."
  },
  [ReportTypes.IvrSurvey]: {
    slug: "ivr-encuesta-de-satisfacción",
    text:
      "Analiza los resultados de las encuestas automáticas post-llamada para conocer la percepción de tus clientes."
  },
  [ReportTypes.MessagingTickets]: {
    slug: "reporte-tickets-mensajeria",
    text:
      "Visualiza los tickets gestionados por mensajería y también analiza el ciclo de atención, asignaciones, estados finales y la trazabilidad de cada conversación."
  },
  [ReportTypes.Strategies]: {
    slug: "reporte-estrategias",
    text:
      "Visualiza todos los registros procesados por las estrategias de un tipo específico."
  },
  [ReportTypes.Phones]: {
    slug: "reporte-telefonos",
    text:
      "Visualiza el detalle de los teléfonos registrados para una empresa determinada y monitorea la validez, estado y resultados de contacto."
  },
  [ReportTypes.LeadsResume]: {
    slug: "reporte-resumen-leads",
    text:
      "Visualiza la cantidad de leads gestionados en tus campañas que han sido tipificados y cuántos aún no han sido gestionados."
  },
  [ReportTypes.CapturedLeads]: {
    slug: "reporte-leads-capturados",
    text:
      "Visualiza el detalle de todos los leads capturados durante un período y campaña específica."
  },
  // [ReportTypes.MessageTicketsTransfer]: {
  //   slug: "",
  //   text:
  //     "MessageTicketsTransfer"
  // },
  [ReportTypes.ContactProducts]: {
    slug: "reporte-productos-contacto",
    text:
      "Supervisa la gestión de productos en campañas específicas, audita qué productos están asignados a cada contacto y cuándo fueron registrados o modificados."
  },
  [ReportTypes.CallAttempts]: {
    slug: "reporte-intentos-llamadas-entrantes",
    text:
      "Visualiza el detalle de cada timbrado a agentes durante el flujo de atención de llamadas entrantes, solo estará disponible si la campaña tiene habilitado la opción de “Timbrado de llamadas entrantes”."
  },
  [ReportTypes.CallsAnswered]: {
    slug: "reporte-llamadas-atendidas",
    text:
      "Conoce el total de llamadas entrantes que han sido efectivamente atendidas por los agentes."
  },
  [ReportTypes.IncomingPerAgent]: {
    slug: "reporte-llamadas-entrantes-agentes",
    text:
      "Visualiza cuántas llamadas fueron o no atendidas por cada agente, incluyendo las que no fueron respondidas por ningún agente."
  },
  [ReportTypes.Callback]: {
    slug: "reporte-llamadas-no-atendidas",
    text:
      "Evalua la capacidad de respuesta del equipo, detectar problemas de disponibilidad y optimiza la gestión de colas."
  },
  [ReportTypes.AtcMessaging]: {
    slug: "reporte-atc-messaging",
    text:
      "Evalúa la eficiencia de tus agentes y la calidad de la atención brindada en los canales de mensajería. "
  }
}